import styles from './slide.module.scss';
import MaterialSlide from '@mui/material/Slide';

/* eslint-disable-next-line */
export interface SlideProps {
  children: any,
  addEndListener?: any,
  appear?: boolean,
  container?: any,
  direction?: 'down' | 'left' | 'right' | 'up',
  easing?: { enter?: string, exit?: string } | string,
  in?: boolean,
  timeout?: number | { appear?: number, enter?: number, exit?: number }
}

export function Slide(props: SlideProps) {
  return (
    <MaterialSlide
      direction={props.direction}
      in={props.in}
      addEndListener={props.addEndListener}
      appear={props.appear}
      container={props.container}
      easing={props.easing}
      timeout={props.timeout}>
      {props.children}
    </MaterialSlide>
  );
}

export default Slide;